const account_center = {
    not_enabled: 'مركز الحسابات غير ممكّن.',
    field_not_editable: 'الحقل غير قابل للتعديل.',
    field_not_enabled: 'الحقل غير ممكّن.',
};
export default Object.freeze(account_center);
